import { RequestParamsMaker } from "./make_request_params";
import axios from "axios";
import CognitoController from "../../../common/scripts/cognito_controller";
import MstGraphService from "@/services/mst_graph_service";

const makeTypes = (self: { [key: string]: any }, indexes: number[]) => {
  const types: string[] = Object.assign([], self.graphTypes);
  indexes.forEach((index: number) => {
    types.splice(index, 1);
  });
  return types;
};

const makeGraphIDs = (self: { [key: string]: any }, indexes: number[]) => {
  const graphIDs: number[] = Object.assign([], self.graphIDs);
  indexes.forEach((index: number) => {
    graphIDs.splice(index, 1);
  });
  return graphIDs;
};

const getIndex = (self: { [key: string]: any }, graphID: number) => {
  const deleteArray: number[] = [];
  self.graphIDs.forEach((id: number, index: number) => {
    if (Number(id) === Number(graphID)) {
      deleteArray.push(index);
    }
  });
  deleteArray.reverse();
  return deleteArray;
};

const undoCognito = async (self: { [key: string]: any }) => {
  const cognitoController = new CognitoController();
  cognitoController.setGraphTypes(self.graphTypes);
  cognitoController.setGraphIDs(self.graphIDs);

  await cognitoController.update();
};

const updateCognito = async (graphID: number, self: { [key: string]: any }) => {
  const cognitoController = new CognitoController();
  const deleteIndex = getIndex(self, graphID);
  const types = makeTypes(self, deleteIndex);
  const graphIDs = makeGraphIDs(self, deleteIndex);
  cognitoController.setGraphTypes(types);
  cognitoController.setGraphIDs(graphIDs);

  await cognitoController.update();

  return {
    graphIDs,
    graphTypes: types
  };
};

const setNewAttribute = (
  self: { [key: string]: any },
  newAttribute: { [key: string]: any }
) => {
  Object.keys(newAttribute).forEach((key: string) => {
    self[key] = newAttribute[key];
  });
};

const deleteMstGraph = (
  graphID: number,
  self: { [key: string]: any },
  userID: string
) => {
  return new Promise(async (resolve, reject) => {
    try {
      const result = await MstGraphService.delete(userID, String(graphID));
      return resolve(result);
    } catch (err) {
      await undoCognito(self);
      return reject(err);
    }
  });
};

export async function confirmDeleteGraph(
  graphID: number,
  self: { [key: string]: any },
  userID: string
) {
  try {
    const updatedAttribute = await updateCognito(graphID, self);
    await deleteMstGraph(graphID, self, userID);
    setNewAttribute(self, updatedAttribute);
    return;
  } catch (err) {
    console.error(err);
    return err;
  }
}
